/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef, Suspense, useMemo } from "react";

import "../../../app/custom.scss";
import BackBtn from "../../../assets/BackArrow.svg";
import BackArrowWhite from "../../../assets/WhiteIcons/BackArrow_White.svg";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import addFilterIcon from "../../../assets/FilterInsight.svg";
import InfoBar from "./DeepDiveInfoBar/index";
import DeepDiveTab from "./DeepDivetab";
import { useDispatch, useSelector } from "react-redux";
import {
  setClearDeepDiveResponse,
  setDetailedInsightObj,
  setIsDetailedInsightVisible,
  setFilter,
  setDeepDiveFlag,
  setDeepDiveInfoLoader,
} from "../../../redux/actions/DeepDive";
import {
  getPaneIndex,
  getWindowLocationPath,
  getAllShareFilters,
  getAllFilters,
  mergeSimilarAttributeInTooltip,
  deepCopy,
  simpleKFormatterOnly,
} from "../../../redux/constants";
import ErrorBoundary from "../../../ErrorBoundary";
import {
  clearDeepDiveObjectWithOthers,
  setDeepDiveNewsObject,
  setDeepDiveSocialMediaObject,
  set_WM_DeepDive,
} from "../../../redux/actions/WidgetMaker/WidgetMaker";

import { getAllWidgetScreenFilters } from "../../../redux/constants/commandCenterConstants";
import {
  setisDeepDive,
  setIsProlificUserDeepDive,
} from "../../../redux/actions/dashboard/Tab1";
import isEqual from "react-fast-compare";
import { SecondstoHumanReadable } from "../../utils/charts/HighCharts/graphFunction";
import {
  setDeletePostFlag,
  setMarkInfluencersFlag,
  setScreenIsDeepDive,
  setScreenSettingFlag,
} from "../../../redux/actions/commandCenter/screens/screen";
import aiStars from "../../../assets/WidgetMaker/ai_stars-icon.svg";
import SmartGrid from "../DeepDive/DeepDivetab/SmartGrid";
import FilterLogo from "../../../assets/Filter_Logo.svg";
import { Tooltip, Badge } from "antd";
import {
  setIsWidgetEdit,
  setisFilterPanelVisible,
} from "../../../redux/actions/Filter";
import { setEditPanel } from "../../../redux/actions/dashboard/dashboard";
import FilterDrawer from "../../layout/Workspace/drawers/FilterDrawer";
import moment from "moment";
import TwitterTrendDeepDive from "./TwitterTrendDeepDive/TwitterTrendDeepDive";
import GoogleTrendDeepDive from "./GoogleTrendDeepdive/GoogleTrendDeepDive";
import Locations from "./DeepDivetab/Locations";
import { setIsDeepDiveInDashboardTemplateData } from "../../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";

const Mentions = React.lazy(() => import("./DeepDivetab/Mentions/index"));
const Author = React.lazy(() => import("./DeepDivetab/Author/index"));
const Category = React.lazy(() => import("./DeepDivetab/Category/index"));
const Influencer = React.lazy(() => import("./DeepDivetab/Influencers/index"));
const SourceOfPost = React.lazy(() =>
  import("./DeepDivetab/SourceOfPost/index")
);
const TimeLocation = React.lazy(() =>
  import("./DeepDivetab/Time&Location/index")
);
const Wordcloud = React.lazy(() => import("./DeepDivetab/Wordcloud/index"));
const AITagged = React.lazy(() =>
  import("./DeepDivetab/AITaggedInsights/index")
);
const EngagingGraph = React.lazy(() =>
  import("./DeepDivetab/EngagingVisuals/index")
);

const DeepDive = () => {
  const divRef = useRef();
  const infoRef = useRef();
  const dispatch = useDispatch();
  const [addFilter, setAddFilter] = useState({
    primaryFilter: false,
    secondaryFilter: false,
  });
  const [visible, setVisible] = useState(true);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const isDetailedInsightVisible = useSelector(
    (state) => state.DeepDive.isDetailedInsightVisible
  ); //deep dive modal state
  const deepDiveTab = isDetailedInsightVisible?.key;
  const deepdive_object = useSelector(
    (state) => state.WidgetMaker.deepdive_object
  );
  const dataType = useSelector((state) => state.DeepDive.datatype);
  const infoLoader = useSelector((state) => state.DeepDive.infoLoader);
  const panes = useSelector((state) => state.Tab1.panes);
  const paneValue = useSelector((state) => state.Workspace.paneValue);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareSelectedDeepdiveWidget = useSelector(
    (state) => state?.Share?.share_selected_deepdive_widget
  );

  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const graphConditionConfigData = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const screen = useSelector((state) => state.Screens.screen);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const isFilterPanelVisible = useSelector(
    (state) => state.Filter.isFilterPanelVisible
  );
  let index = getPaneIndex(panes, activeKey);
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const screenSettingFlag = useSelector(
    (state) => state?.Screens?.screen_setting_flag
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  let pathName = getWindowLocationPath()?.toLowerCase();
  const [filterSearch, setfilterSearch] = useState("");
  const [filterClearTrigger, setfilterClearTrigger] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const section_index =
    shareBrands && shareSelectedDeepdiveWidget
      ? shareSelectedDeepdiveWidget?.section_index
      : pathName === "CommandCenter"?.toLowerCase()
      ? screen?.selected_deepdive_widget?.section_index
      : panes[index]
      ? panes[index]?.selected_deepdive_widget?.section_index
      : null;
  const widget_index =
    shareBrands && shareSelectedDeepdiveWidget
      ? shareSelectedDeepdiveWidget?.widget_index
      : pathName === "CommandCenter"?.toLowerCase()
      ? screen?.selected_deepdive_widget?.widget_index
      : panes[index]
      ? panes[index]?.selected_deepdive_widget?.widget_index
      : null;
  const getCommandCenterWidgetData = (
    sectionIndex,
    screenData,
    widgetIndex
  ) => {
    if (sectionIndex >= 0 && screenData?.sections) {
      return screenData?.sections[sectionIndex]?.widgets?.[widgetIndex];
    } else if (sectionIndex === null && screenData?.section?.[0]?.widgets) {
      return screenData?.section[0]?.widgets?.[widgetIndex];
    } else {
      return screenData?.widgets?.[widgetIndex];
    }
  };
  const widget_metadata =
    !shareBrands && pathName === "CommandCenter"?.toLowerCase()
      ? getCommandCenterWidgetData(section_index, screen, widget_index)
      : !shareBrands &&
        section_index >= 0 &&
        panes[index]?.sections?.[section_index]?.widgets
      ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : !shareBrands
      ? panes[index]?.section?.[0]?.widgets?.[widget_index]
      : null;

  // BrandIds Commnent for code patching
  let brandIds = shareBrands
    ? shareTemplateData?.brand_ids
    : pathName === "CommandCenter"?.toLowerCase()
    ? widget_metadata?.brand_ids
    : panes?.[index]?.sections && section_index >= 0
    ? panes?.[index]?.sections?.[section_index]?.widgets &&
      panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
    : panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.brand_groups
    ? panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.brand_groups
    : null;

  const aiActionableData = shareTemplateData
    ? shareTemplateData?.deep_dive?.ai_actionable?.result?.data?.grid?.[0]
    : panes[index]?.deep_dive?.ai_actionable?.result?.data?.grid?.[0];

  const templateUsageGrid = shareTemplateData
    ? shareTemplateData?.deep_dive?.template_usage_grid?.result?.data?.grid?.[0]
    : panes[index]?.deep_dive?.template_usage_grid?.result?.data?.grid?.[0];

  // for deep dive data for attribute -> tickets || or work flow chart attributes
  const ticketChartData = shareTemplateData
    ? shareTemplateData?.deep_dive?.ticket_chart?.result?.data?.grid?.[0]
    : panes[index]?.deep_dive?.ticket_chart?.result?.data?.grid?.[0];
  const handleCancel = () => {
    dispatch(setIsDeepDiveInDashboardTemplateData(false));

    if (pathName === "CommandCenter"?.toLowerCase()) {
      window.stop();
      dispatch(setMarkInfluencersFlag(false));
      dispatch(setDeletePostFlag(false));

      dispatch(setDeepDiveFlag(false));
      dispatch(
        setIsDetailedInsightVisible({
          value: false,
          tab_id: null,
          name:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "Word Cloud"
              : "Mentions",
          key:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "2"
              : "1",
        })
      );
      dispatch(setDetailedInsightObj(null));
      dispatch(setClearDeepDiveResponse(null));

      dispatch({ type: "SET_DEEP_DIVE_INFOBAR", payload: null });
      let updateShareTemplateData = shareTemplateData && {
        ...shareTemplateData,
      };
      if (updateShareTemplateData) {
        updateShareTemplateData.isDeepDive = false;
        updateShareTemplateData.is_prolific_user_deep_dive = false;
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }

      let deep_dive_object = {
        infoBar: null,
        mentions: null,
        wordcloud: [],
        category: [],
        top_users: [],
        influencers: [],
        source_of_post: [],
        locations: [],
      };
      // To close Deep Dive Modal
      dispatch(setScreenIsDeepDive(false, deep_dive_object));

      dispatch(set_WM_DeepDive(false));
      dispatch(setIsProlificUserDeepDive(false, panes, index));
      document.body.style = "";

      // to clear social media the page no
      let social_media_object = {
        order_by: {
          attribute: "engagement",
          offset: 0,
          sort_order: "desc",
        },
      };
      dispatch(setDeepDiveSocialMediaObject(social_media_object));
      // to clear news the page no
      let news_object = {
        order_by: {
          attribute: "engagement",
          offset: 0,
          sort_order: "desc",
        },
      };
      dispatch(setDeepDiveNewsObject(news_object));
    } else {
      window.stop();

      dispatch(setDeepDiveFlag(false));
      let index = getPaneIndex(panes, activeKey);
      dispatch(
        setIsDetailedInsightVisible({
          value: false,
          tab_id: null,
          name:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "Word Cloud"
              : "Mentions",
          key:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "2"
              : "1",
        })
      );
      dispatch(setDetailedInsightObj(null));
      dispatch(setClearDeepDiveResponse(null));

      dispatch({ type: "SET_DEEP_DIVE_INFOBAR", payload: null });
      let updateShareTemplateData = shareTemplateData && {
        ...shareTemplateData,
      };
      if (updateShareTemplateData) {
        updateShareTemplateData.isDeepDive = false;
        updateShareTemplateData.is_prolific_user_deep_dive = false;
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }

      !shareBrands && dispatch(setisDeepDive(false, panes, index));
      dispatch(set_WM_DeepDive(false));
      dispatch(setIsProlificUserDeepDive(false, panes, index));
      document.body.style = "";

      // to clear social media the page no
      let social_media_object = {
        order_by: {
          attribute: "engagement",
          offset: 0,
          sort_order: "desc",
        },
      };
      dispatch(setDeepDiveSocialMediaObject(social_media_object));
      // to clear news the page no
      let news_object = {
        order_by: {
          attribute: "engagement",
          offset: 0,
          sort_order: "desc",
        },
      };
      dispatch(setDeepDiveNewsObject(news_object));
    }
    // to clear deep dive object , sub_deep_dive_on not reseting
    dispatch(clearDeepDiveObjectWithOthers());
  };

  const handleFilter = (attribute, name, datatype) => {
    let value;
    if (datatype === "varchar") {
      value = {
        type: "include",
        name: name,
        attribute: attribute,
        datatype: datatype,
      };
    }
    dispatch(setFilter(value));
    handleCancel();
  };

  const controlNavbar = () => {
    if (divRef?.current?.clientWidth > 769) {
      if (divRef?.current?.clientHeight > 600) {
        if (window.scrollY > infoRef?.current?.clientHeight) {
          setVisible(false);
        } else if (window.scrollY < infoRef?.current?.clientHeight - 80) {
          setVisible(true);
        }
      } else if (divRef?.current?.clientHeight < 540) {
        if (window.scrollY === 0) {
          setVisible(true);
        }
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);

  const filters = useMemo(() => {
    return deepdive_object?.filters &&
      Array.isArray(deepdive_object?.filters) &&
      deepdive_object?.filters?.length > 0
      ? deepdive_object?.filters
      : [];
  }, [deepdive_object]);
  const finalFilter = mergeSimilarAttributeInTooltip(
    Array.isArray(filters) && filters?.length ? deepCopy(filters) : []
  );
  const handleClickOnFilterIcon = () => {
    if (isWidgetEdit) dispatch(setIsWidgetEdit(false));
    if (screenSettingFlag) dispatch(setScreenSettingFlag(false));
    dispatch(setisFilterPanelVisible(true));
    dispatch(setEditPanel(null));
  };
  const removeFilterPanel = () => {
    dispatch(setisFilterPanelVisible(false));
    setfilterSearch("");
  };

  return (
    <>
      <div
        className={`${
          authParams?.template_id ? "detailedInsight__nav-v3 " : " "
        } detailedInsight__nav box-shadow_bottom`}
        style={shareTemplateData ? { top: "0" } : {}}
      >
        <div className="detailedInsight__nav-FilterBar  d-flex flex-wrap align-items-center justify-content-between p-15 border-bottom">
          <div
            className="d-flex cursor-pointer align-items-center"
            onClick={() => handleCancel()}
          >
            {/* <img
              className="RecentlySaved__header__left__arrow mr-1 ml-0"
              src={authParams?.theme_type === "1" ? BackArrowWhite : BackBtn}
              alt="Back Arrow"
            /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              className="RecentlySaved__header__left__arrow mr-1 ml-0"
              style={{
                fill: "var(--locobuzz-primary-text-color, #3b5175)",
                cursor: "pointer",
              }}
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
                fill="var(--locobuzz-primary-text-color)"
              />
            </svg>

            <span className={`text_regular font-weight600 deepdive__span `}>
              Back
            </span>
          </div>
          {deepdive_object?.deepdive_on?.deep_dive_id &&
          deepdive_object?.deepdive_on?.widget_inner_id ? (
            <>
              <div
                className="d-flex flex-wrap align-items-center justify-content-center"
                // style={{ width: "calc(100% - 8rem)" }}
              >
                <img
                  style={{
                    margin: "0.5rem",
                    width: "1.4rem",
                    height: "1.9rem",
                  }}
                  src={aiStars}
                />
                <span
                  className="text_regular mr-1"
                  style={{ fontWeight: "600" }}
                >
                  {deepdive_object?.deepdive_on?.name}
                </span>
              </div>
            </>
          ) : deepdive_object?.account_list?.length > 0 ? (
            <>
              {/* To display template title in template usage details */}
              <div
                className="d-flex flex-wrap align-items-center justify-content-center"
                style={{ width: "calc(100% - 8rem)" }}
              >
                {deepdive_object?.deepdive_on?.x_axis && (
                  <div className="mr-15">
                    <span className="text_regular font-weight600 deepdive__span">
                      {deepdive_object?.deepdive_on?.x_axis?.trace_name && (
                        <>{deepdive_object?.deepdive_on?.x_axis?.trace_name}</>
                      )}
                    </span>
                    {(dataType.primaryType === "varchar" ||
                      dataType.primaryType === "int") && (
                      <img
                        className="cursor-pointer"
                        alt="apply filter"
                        src={addFilterIcon}
                        onClick={() => {
                          handleFilter(
                            paneValue?.deep_dive?.attribute?.primary,
                            paneValue?.deep_dive?.deep_dive?.primary,
                            dataType.primaryType
                          );
                          setAddFilter({
                            ...addFilter,
                            primaryFilter: true,
                          });
                        }}
                      />
                    )}
                  </div>
                )}

                {/* {deepdive_object?.deepdive_on?.y_axis && (
                  <div className="mr-15">
                    <span className="text_regular mr-1">Y-Attribute:</span>
                    <span className="text_regular font-weight600 deepdive__span">
                      {deepdive_object?.deepdive_on?.y_axis?.trace_name && (
                        <>
                          {deepdive_object?.deepdive_on?.y_axis?.trace_name} (
                          {deepdive_object?.deepdive_on?.y_axis?.value})
                        </>
                      )}
                    </span>
                    {(dataType.primaryType === "varchar" ||
                      dataType.primaryType === "int") && (
                      <img
                        className="cursor-pointer"
                        alt="apply filter"
                        src={addFilterIcon}
                        onClick={() => {
                          handleFilter(
                            paneValue?.deep_dive?.attribute?.secondary,
                            paneValue?.deep_dive?.deep_dive?.secondary,
                            dataType.secondaryType
                          );
                          setAddFilter({
                            ...addFilter,
                            secondaryFilter: true,
                          });
                        }}
                      />
                    )}
                  </div>
                )}

                {deepdive_object?.deepdive_on?.y_series && (
                  <div className="mr-15">
                    <span className="text_regular mr-1">Y-Series:</span>
                    {authParams?.screen_id && screen?.deletePostFlag ? (
                      <>
                        <Tooltip title="To see the updated number, refresh the screen.">
                          <span
                            style={{ color: "lightgrey" }}
                            className="font-weight600"
                          >
                            {deepdive_object?.deepdive_on?.y_series?.trace_name}{" "}
                            (
                            {graphConditionConfigData?.[
                              "time-label-attrs"
                            ]?.includes(
                              deepdive_object?.deepdive_on?.y_series?.attribute
                            )
                              ? SecondstoHumanReadable(
                                  deepdive_object?.deepdive_on?.y_series?.value
                                )
                              : simpleKFormatterOnly(
                                  deepdive_object?.deepdive_on?.y_series?.value
                                )}
                            )
                          </span>
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <span className="text_regular font-weight600 deepdive__span">
                          {deepdive_object?.deepdive_on?.y_series?.trace_name} (
                          {graphConditionConfigData?.[
                            "time-label-attrs"
                          ]?.includes(
                            deepdive_object?.deepdive_on?.y_series?.attribute
                          )
                            ? SecondstoHumanReadable(
                                deepdive_object?.deepdive_on?.y_series?.value
                              )
                            : simpleKFormatterOnly(
                                deepdive_object?.deepdive_on?.y_series?.value
                              )}
                          )
                        </span>
                      </>
                    )}
                  </div>
                )} */}
              </div>
            </>
          ) : (
            <>
              {/* To display template title in template usage details */}
              <div
                className="d-flex flex-wrap align-items-center justify-content-center"
                style={{ width: "calc(100% - 8rem)" }}
              >
                {deepdive_object?.deepdive_on?.x_axis && (
                  <div className="mr-15">
                    <span className="text_regular mr-1">
                      {shareTemplateData?.is_prolific_user_deep_dive ||
                      panes?.[index]?.is_prolific_user_deep_dive
                        ? "Author Name:"
                        : "X-Attribute:"}
                    </span>
                    <span className="text_regular font-weight600 deepdive__span">
                      {deepdive_object?.deepdive_on?.x_axis?.trace_name && (
                        <>
                          {deepdive_object?.deepdive_on?.x_axis?.trace_name}{" "}
                          {shareTemplateData?.is_prolific_user_deep_dive ||
                          panes?.[index]?.is_prolific_user_deep_dive ? (
                            ""
                          ) : (
                            <>({deepdive_object?.deepdive_on?.x_axis?.value})</>
                          )}
                        </>
                      )}
                    </span>
                    {(dataType.primaryType === "varchar" ||
                      dataType.primaryType === "int") && (
                      <img
                        className="cursor-pointer"
                        alt="apply filter"
                        src={addFilterIcon}
                        onClick={() => {
                          handleFilter(
                            paneValue?.deep_dive?.attribute?.primary,
                            paneValue?.deep_dive?.deep_dive?.primary,
                            dataType.primaryType
                          );
                          setAddFilter({
                            ...addFilter,
                            primaryFilter: true,
                          });
                        }}
                      />
                    )}
                  </div>
                )}

                {deepdive_object?.chart_type === "cluster-chart" &&
                Array?.isArray(deepdive_object?.deepdive_on?.y_axis?.value)
                  ? ""
                  : deepdive_object?.deepdive_on?.y_axis && (
                      <div className="mr-15">
                        <span className="text_regular mr-1">Y-Attribute:</span>
                        <span className="text_regular font-weight600 deepdive__span">
                          {deepdive_object?.deepdive_on?.y_axis?.trace_name && (
                            <>
                              {deepdive_object?.deepdive_on?.y_axis?.trace_name}{" "}
                              {deepdive_object?.deepdive_on?.y_axis?.value ? (
                                <>
                                  ({deepdive_object?.deepdive_on?.y_axis?.value}
                                  )
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </span>
                        {(dataType.primaryType === "varchar" ||
                          dataType.primaryType === "int") && (
                          <img
                            className="cursor-pointer"
                            alt="apply filter"
                            src={addFilterIcon}
                            onClick={() => {
                              handleFilter(
                                paneValue?.deep_dive?.attribute?.secondary,
                                paneValue?.deep_dive?.deep_dive?.secondary,
                                dataType.secondaryType
                              );
                              setAddFilter({
                                ...addFilter,
                                secondaryFilter: true,
                              });
                            }}
                          />
                        )}
                      </div>
                    )}

                {deepdive_object?.deepdive_on?.y_series &&
                  !deepdive_object?.isSurveyCardBased && (
                    <div className="mr-15">
                      <span className="text_regular mr-1">{`${
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ? "Series 1"
                          : "Y-Series"
                      }:`}</span>
                      {authParams?.screen_id && screen?.deletePostFlag ? (
                        <>
                          <Tooltip title="To see the updated number, refresh the screen.">
                            <span
                              style={{ color: "lightgrey" }}
                              className="font-weight600"
                            >
                              {
                                deepdive_object?.deepdive_on?.y_series
                                  ?.trace_name
                              }{" "}
                              (
                              {graphConditionConfigData?.[
                                "time-label-attrs"
                              ]?.includes(
                                deepdive_object?.deepdive_on?.y_series
                                  ?.attribute
                              ) ||
                              graphConditionConfigData?.[
                                "ticket-time-label-attrs"
                              ]?.includes(
                                deepdive_object?.deepdive_on?.y_series
                                  ?.attribute
                              )
                                ? SecondstoHumanReadable(
                                    deepdive_object?.deepdive_on?.y_series
                                      ?.value
                                  )
                                : simpleKFormatterOnly(
                                    deepdive_object?.deepdive_on?.y_series
                                      ?.value
                                  )}
                              )
                            </span>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <span className="text_regular font-weight600 deepdive__span">
                            {deepdive_object?.deepdive_on?.y_series?.trace_name}{" "}
                            (
                            {graphConditionConfigData?.[
                              "time-label-attrs"
                            ]?.includes(
                              deepdive_object?.deepdive_on?.y_series?.attribute
                            ) ||
                            graphConditionConfigData?.[
                              "ticket-time-label-attrs"
                            ]?.includes(
                              deepdive_object?.deepdive_on?.y_series?.attribute
                            )
                              ? SecondstoHumanReadable(
                                  deepdive_object?.deepdive_on?.y_series?.value
                                )
                              : simpleKFormatterOnly(
                                  deepdive_object?.deepdive_on?.y_series?.value
                                )}
                            )
                          </span>
                        </>
                      )}
                    </div>
                  )}
                {deepdive_object?.deepdive_on?.y_series_secondary ? (
                  <div className="mr-15">
                    <span className="text_regular mr-1">Series 2:</span>
                    <span className="text_regular font-weight600 deepdive__span">
                      {
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ?.trace_name
                      }{" "}
                      (
                      {graphConditionConfigData?.["time-label-attrs"]?.includes(
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ?.attribute
                      ) ||
                      graphConditionConfigData?.[
                        "ticket-time-label-attrs"
                      ]?.includes(
                        deepdive_object?.deepdive_on?.y_series_secondary
                          ?.attribute
                      )
                        ? SecondstoHumanReadable(
                            deepdive_object?.deepdive_on?.y_series_secondary
                              ?.value
                          )
                        : simpleKFormatterOnly(
                            deepdive_object?.deepdive_on?.y_series_secondary
                              ?.value
                          )}
                      )
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
          {/* curretly remove filter from deepdive */}

          {/* {finalFilter && Array.isArray(finalFilter) ? (
            <Tooltip
              overlayStyle={{
                width: screen?.filters?.length > 0 ? "20rem" : "auto",
              }}
              color="#3B5175"
              title={
                finalFilter?.length > 0 ? (
                  <div
                    className="custom_scroll"
                    style={{
                      maxWidth: "27rem",
                      maxHeight: "23rem",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <div className="mb-1">
                      {finalFilter?.map((filterData, index) => {
                        return (
                          <div key={index}>
                            {filterData?.attribute === "BrandID" ? (
                              <div className="mb-2">
                                <p className="mb-0 text-white">
                                  <strong>Brands</strong>
                                </p>
                                <span className="font-weight-light text-white">
                                  {filterData &&
                                    Array.isArray(filterData?.columns) &&
                                    filterData?.columns?.map((el, index) => (
                                      <span
                                        style={{
                                          color: "#fff",
                                          maxHeight: "20rem",
                                          overflow: "auto",
                                        }}
                                      >
                                        {(index ? ", " : "") +
                                          el?.brand_friendly_name}
                                      </span>
                                    ))}
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                            {filterData?.attribute === "CreatedDate" &&
                            filterData?.columns?.from ? (
                              <div className="mb-2">
                                <p className="mb-0 text-white">
                                  <strong>Duration</strong>
                                </p>
                                <span className="font-weight-light text-white">
                                  {filterData && filterData?.columns?.from
                                    ? `
                                    ${
                                      moment(filterData?.columns?.from).format(
                                        "MMM Do YYYY HH:mm"
                                      ) + " to "
                                    }
                                      ${moment(filterData?.columns?.to).format(
                                        "MMM Do YYYY HH:mm"
                                      )}`
                                    : ""}
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                            {filterData?.attribute !== "CreatedDate" &&
                            filterData?.attribute !== "BrandID" ? (
                              <>
                                <p
                                  className="mb-0"
                                  style={{
                                    color:
                                      filterData?.type === "include"
                                        ? "#5ed66d"
                                        : filterData?.type === "exclude" &&
                                          "#fb7665",
                                  }}
                                >
                                  <strong>
                                    {All_Share_attributes
                                      ? All_Share_attributes?.[
                                          filterData?.attribute
                                        ]
                                        ? All_Share_attributes?.[
                                            filterData?.attribute
                                          ]
                                        : filterData?.attribute ===
                                            "SettingID" ||
                                          filterData?.attribute === "AccountID"
                                        ? "Profile"
                                        : filterData?.attribute ===
                                            "Category" ||
                                          filterData?.attribute === "CategoryID"
                                        ? "Category"
                                        : filterData?.attribute === "CampaignID"
                                        ? "Campaign"
                                        : filterData?.attribute === "LocationID"
                                        ? "Location"
                                        : filterData?.attribute?.endsWith("ID")
                                        ? filterData?.attribute?.replace(
                                            "ID",
                                            ""
                                          )
                                        : filterData?.attribute?.replace(
                                            "Type",
                                            ""
                                          )
                                      : filterData?.attribute === "SettingID" ||
                                        filterData?.attribute === "AccountID"
                                      ? "Profile"
                                      : filterData?.attribute === "Category" ||
                                        filterData?.attribute === "CategoryID"
                                      ? "Category"
                                      : filterData?.attribute === "CampaignID"
                                      ? "Campaign"
                                      : filterData?.attribute === "LocationID"
                                      ? "Location"
                                      : filterData?.attribute?.endsWith("ID")
                                      ? filterData?.attribute?.replace("ID", "")
                                      : filterData?.attribute?.replace(
                                          "Type",
                                          ""
                                        )}
                                  </strong>
                                </p>
                                {filterData?.type === "int" &&
                                  !Array.isArray(filterData?.columns) && (
                                    <span className="font-weight-light text-white">
                                      {filterData?.columns?.from +
                                        " - " +
                                        filterData?.columns?.to}
                                    </span>
                                  )}
                                <div>
                                  {Array.isArray(filterData?.columns) &&
                                    filterData?.columns?.map((e, index) => {
                                      return (
                                        <span
                                          className="font-weight-light"
                                          style={{
                                            color:
                                              e?.type === "include"
                                                ? "#5ed66d"
                                                : e?.type === "exclude"
                                                ? "#fb7665"
                                                : "#fff",
                                          }}
                                        >
                                          {[
                                            "FeedBackEnabled",
                                            "ShowDeletedFromSocial",
                                            "AutoClosureEnabled",
                                            "IsWorkingHour",
                                          ]?.includes(filterData?.attribute)
                                            ? e?.name === null
                                              ? "Any"
                                              : e?.name === 0
                                              ? "No"
                                              : e?.name === 1 && "Yes"
                                            : (index ? ", " : "") +
                                              (e?.display_name
                                                ? e?.display_name
                                                : e?.name)}
                                        </span>
                                      );
                                    })}
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  "Filters"
                )
              }
              placement="leftTop"
            >
              <Badge
                size="small"
                count={finalFilter ? finalFilter?.length : 0}
                title=""
                showZero
              >
                <img
                  className="Screen__icons--filter cursor-pointer"
                  src={FilterLogo}
                  onClick={handleClickOnFilterIcon}
                />
              </Badge>
            </Tooltip>
          ) : (
            ""
          )} */}
          {/* Tempraly added bacause justify-content-between is applied on parent div */}
          <div></div>
        </div>

        {(deepdive_object?.deepdive_on?.deep_dive_id &&
          deepdive_object?.deepdive_on?.widget_inner_id) ||
        deepdive_object?.account_list?.length > 0 ||
        deepdive_object?.isWorkFlowBased ||
        deepdive_object?.isTicketBased ||
        [
          "000-000-567", // for twitter screen
          "000-000-566", // for google screen
        ]?.includes(authParams?.screen_id) ? (
          <></>
        ) : (
          <>
            <div
              className={`animated border-bottom
          ${visible ? "scrollVisible" : "unvisible"}
          `}
              ref={infoRef}
            >
              <ErrorBoundary>
                <InfoBar />
              </ErrorBoundary>
            </div>
            <ErrorBoundary>
              <DeepDiveTab tabId={deepDiveTab} />
            </ErrorBoundary>
          </>
        )}
      </div>
      <div className="container-fluid bg__gray pt-15 pb-15" ref={divRef}>
        {[
          "000-000-567", // for twitter screen
        ]?.includes(authParams?.screen_id) ? (
          <>
            <TwitterTrendDeepDive />
          </>
        ) : [
            "000-000-566", // for google screen
          ]?.includes(authParams?.screen_id) ? (
          <>
            <GoogleTrendDeepDive />
          </>
        ) : (deepdive_object?.deepdive_on?.deep_dive_id &&
            deepdive_object?.deepdive_on?.widget_inner_id) ||
          deepdive_object?.account_list?.length > 0 ||
          ticketChartData ||
          deepdive_object?.isWorkFlowBased ||
          deepdive_object?.isTicketBased ? (
          <>
            {infoLoader ? (
              <div
                className={`loader ${
                  authParams?.theme_type === "1" ? "" : "portlet1"
                }`}
                style={{ height: visible ? "" : "calc(100vh - 17.2rem)" }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : deepdive_object?.deepdive_on?.widget_inner_id ||
              deepdive_object?.account_list?.length > 0 ||
              ticketChartData ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <SmartGrid
                    ticketChartData={ticketChartData}
                    widget_metadata={
                      shareBrands
                        ? shareTemplateData?.section &&
                          shareTemplateData?.section?.[0]
                          ? shareTemplateData?.section &&
                            shareTemplateData?.section?.[0]?.widgets?.[
                              shareSelectedDeepdiveWidget?.widget_index
                            ]
                          : shareTemplateData?.sections &&
                            shareTemplateData?.sections?.[
                              shareSelectedDeepdiveWidget?.section_index
                            ]
                          ? shareTemplateData?.sections?.[
                              shareSelectedDeepdiveWidget?.section_index
                            ]?.widgets?.[
                              shareSelectedDeepdiveWidget?.widget_index
                            ]
                          : shareTemplateData?.widgets?.[
                              shareSelectedDeepdiveWidget?.widget_index
                            ]
                          ? shareTemplateData?.widgets?.[
                              shareSelectedDeepdiveWidget?.widget_index
                            ]
                          : widget_metadata
                        : widget_metadata
                    }
                    tableColumns={
                      ticketChartData
                        ? ticketChartData?.columns
                        : deepdive_object?.account_list?.length > 0
                        ? templateUsageGrid?.columns
                        : aiActionableData?.columns
                    }
                    dataSource={
                      ticketChartData
                        ? ticketChartData?.dataSource
                        : deepdive_object?.account_list?.length > 0
                        ? templateUsageGrid?.dataSource
                        : aiActionableData?.dataSource
                    }
                    colors={
                      ticketChartData
                        ? ticketChartData?.colors
                        : deepdive_object?.account_list?.length > 0
                        ? templateUsageGrid?.colors
                        : aiActionableData?.colors
                    }
                    hideColumns={
                      ticketChartData ? ticketChartData?.hide_columns : null
                    }
                    widget_id={
                      deepdive_object?.isWorkFlowBased
                        ? "8.1"
                        : deepdive_object?.isTicketBased
                        ? deepdive_object?.ticketDeepDiveWidgetId || "6.1"
                        : ""
                    }
                  />
                </Suspense>
              </ErrorBoundary>
            ) : (
              <div
                className="portlet_images text-center pt-4 mt-15 mb-15 col-12 d-flex align-items-center"
                style={{ minHeight: "45rem" }}
              >
                <div className="m-auto">
                  <img
                    alt="no data"
                    src={somethingWentWrong}
                    style={{ maxWidth: "100%", minWidth: "20rem" }}
                  />
                  <p className="mt-15 text_regular-gray">No Data Found</p>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {infoLoader ? (
              <div
                className={`loader ${
                  authParams?.theme_type === "1" ? "" : "portlet1"
                }`}
                style={{ height: visible ? "" : "calc(100vh - 17.2rem)" }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : deepDiveTab === "1" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <Mentions tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "2" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <Wordcloud tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "3" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <Category tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "4" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <Influencer tabId={deepDiveTab} />
                  {/* <Author tabId={deepDiveTab} /> */}
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "5" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <SourceOfPost tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "6" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <TimeLocation tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "7" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <AITagged tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "8" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <EngagingGraph visible={visible} tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "9" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <Author tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : deepDiveTab === "10" ? (
              <ErrorBoundary deepDiveTab={true}>
                <Suspense fallback={""}>
                  <Locations tabId={deepDiveTab} />
                </Suspense>{" "}
              </ErrorBoundary>
            ) : null}
          </>
        )}

        {/* global_dashboard
          share_modal
          template_global
          widgetMaker
          graph_page
        */}

        {/* {isFilterPanelVisible && (
          <FilterDrawer
            onClose={removeFilterPanel}
            setfilterSearch={setfilterSearch}
            filterSearch={filterSearch}
            filterClearTrigger={filterClearTrigger}
            setfilterClearTrigger={setfilterClearTrigger}
            drawer={true}
            type={shareBrands ? "share_modal" : "deep_dive_global"}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        )} */}
      </div>
    </>
  );
};
export default React.memo(DeepDive, isEqual);
